(function () {
  'use strict';
  if (window.WVProductDetails) { window.WVProductDetails.init(); return; }
  const instances = new WeakMap();
  const models = new Set(['500', '500pro', 'ac-core', 'b500']);
  class ProductDetails {
    constructor(root) {
      this.root = root;
      this.content = root.querySelector('[data-wvpd-content]');
      this.model = root.dataset.defaultModel;
      this.bundleMode = root.hasAttribute('data-wvpd-bundle');
      this.profiles = new Map([[this.model, this.content.cloneNode(true)]]);
      root.querySelectorAll('template[data-wvpd-model]').forEach(template => this.profiles.set(template.dataset.wvpdModel, template.content));
      this.controllers = new AbortController();
      if ('IntersectionObserver' in window) {
        this.readingObserver = new IntersectionObserver(entries => {
          this.root.toggleAttribute('data-wvpd-reading', entries.some(entry => entry.isIntersecting));
        });
        this.readingObserver.observe(root);
      }
      document.addEventListener('wv:configuration-change', event => {
        if (this.bundleMode) return;
        if (this.root.dataset.defaultModel === 'b500') return;
        if (!event.target.matches('[data-wv-500-series]')) return;
        this.sync(event.detail);
      }, { signal: this.controllers.signal });
      root.addEventListener('click', event => {
        const descriptionLink = event.target.closest('[data-wvpd-description]');
        if (descriptionLink) {
          const target = document.getElementById(descriptionLink.hash.slice(1));
          const description = target?.querySelector('[data-wv-bundle-description]');
          const summary = description?.querySelector('summary');
          if (description && summary) {
            event.preventDefault();
            description.open = true;
            summary.scrollIntoView({ block: 'center', behavior: 'auto' });
            summary.focus({ preventScroll: true });
          }
          return;
        }
        const link = event.target.closest('[data-wvpd-configure]');
        if (!link) return;
        const configuration = document.querySelector('[data-wv-500-series]');
        if (!configuration) return;
        event.preventDefault();
        const group = link.dataset.wvpdConfigure === 'capacity' ? 'capacity' : 'model';
        const fieldset = configuration.querySelector('fieldset[data-group="' + group + '"]');
        (fieldset || configuration).scrollIntoView({ block: 'center', behavior: 'auto' });
        const firstInput = configuration.querySelector('input[data-group="' + group + '"]:checked');
        firstInput?.focus({ preventScroll: true });
      }, { signal: this.controllers.signal });
      const configuration = document.querySelector('[data-wv-500-series]');
      if (configuration && !this.bundleMode && this.model !== 'b500') this.sync({ model: configuration.dataset.model });
      this.observeComparison();
    }
    sync(detail) {
      if (!detail || !models.has(detail.model) || !this.profiles.has(detail.model)) return;
      if (detail.model !== this.model) {
        const profile = this.profiles.get(detail.model);
        const focused = this.root.contains(document.activeElement);
        this.content.replaceChildren(...[...profile.childNodes].map(node => node.cloneNode(true)));
        this.model = detail.model;
        this.observeComparison();
        if (focused) this.content.querySelector('a')?.focus({ preventScroll: true });
      }
      this.root.dataset.model = this.model;
      this.syncSelection();
    }
    observeComparison() {
      this.comparisonObserver?.disconnect();
      const wrapper = this.content.querySelector('.wvpd__compare-wrap');
      if (!wrapper) return;
      let previousWidth = -1;
      const alignCurrentModel = () => {
        if (wrapper.clientWidth === previousWidth) return;
        previousWidth = wrapper.clientWidth;
        const table = wrapper.querySelector('table');
        const selected = table?.querySelector('thead [data-current-model="true"]');
        const label = table?.querySelector('thead th:first-child');
        if (!selected || !label) return;
        const offset = selected.getBoundingClientRect().left - table.getBoundingClientRect().left - label.getBoundingClientRect().width;
        wrapper.scrollLeft = Math.max(0, offset);
      };
      alignCurrentModel();
      if ('ResizeObserver' in window) {
        this.comparisonObserver = new ResizeObserver(alignCurrentModel);
        this.comparisonObserver.observe(wrapper);
      }
    }
    syncSelection() {
      const list = this.content.querySelector('[data-wvpd-items]');
      const fallback = this.content.querySelector('[data-wvpd-items-fallback]');
      if (!list) return;
      const rows = document.querySelectorAll('[data-wv-500-series] [data-wvc-breakdown] li > span');
      list.replaceChildren(...Array.from(rows, row => {
        const item = document.createElement('li');
        item.textContent = row.textContent;
        return item;
      }));
      list.hidden = !rows.length;
      if (fallback) fallback.hidden = rows.length > 0;
      const note = this.content.querySelector('[data-wvpd-selection-note]');
      if (note) {
        note.textContent = document.querySelector('[data-wv-500-series] [data-wvc-availability]')?.textContent || '';
        note.hidden = !note.textContent.trim();
      }
    }
    destroy() {
      this.readingObserver?.disconnect();
      this.comparisonObserver?.disconnect();
      this.root.removeAttribute('data-wvpd-reading');
      this.controllers.abort();
    }
  }
  function init(container = document) {
    container.querySelectorAll('[data-wvpd]').forEach(root => {
      if (!instances.has(root)) instances.set(root, new ProductDetails(root));
    });
  }
  window.WVProductDetails = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-wvpd]').forEach(root => {
    instances.get(root)?.destroy();
    instances.delete(root);
  }));
  init();
})();
